'use client';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-white text-[#0f172a]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#1a56ff] mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold mb-2">Cookie Policy</h1>
        <p className="text-xs text-slate-400 mb-10">Last updated: January 2026</p>
        <div className="space-y-8 text-sm text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">What Are Cookies?</h2>
            <p>Cookies are small text files stored on your device when you visit a website. They help us remember your preferences and improve your experience on dropservice.in.</p>
          </section>
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Types of Cookies We Use</h2>
            <div className="space-y-4">
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="text-sm font-semibold text-[#0f172a] mb-1">Essential Cookies</h3>
                <p>Required for the platform to function. These include session cookies that keep you logged in and security cookies that protect your account.</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="text-sm font-semibold text-[#0f172a] mb-1">Analytics Cookies</h3>
                <p>Help us understand how agents use the platform so we can improve it. Data collected is aggregated and anonymous.</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="text-sm font-semibold text-[#0f172a] mb-1">Preference Cookies</h3>
                <p>Remember your settings and preferences so you do not have to re-enter them each time you visit.</p>
              </div>
            </div>
          </section>
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Managing Cookies</h2>
            <p>You can control and delete cookies through your browser settings. Note that disabling essential cookies may affect the functionality of the platform.</p>
          </section>
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Contact</h2>
            <p>For cookie-related queries, contact us at <a href="mailto:support@dropservice.in" className="text-[#1a56ff] hover:underline">support@dropservice.in</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
